import {Service} from 'typedi';
import {StrategyBuilder} from '../../StrategyBuilder';
import {GuidedV2Defaults, GuidedV2StrategyService, type GuidedV2StrategyData} from '../../GuidedV2StrategyService';
import {GuidedV2DefaultService} from './guided-v2-fallback.service';
import {predefinedConfigs} from './predefined-config';

/**
 * Derived type for building the guided configuration, additional fields
 * are generally useless for GuidedV2 itself, but help booting it up
 */
export type GuidedV2StrategyDataStarter = Partial<GuidedV2StrategyData> & {
  predefined?:string,
  external?:string
};

type LocaleHack = {
  country: string,
  language: string
};

@Service({id: 'GuidedV2DefaultStrategyService'})
export class GuidedV2DefaultServiceBuilder extends StrategyBuilder<GuidedV2StrategyService> {

  /**
   * Build a GuidedV2StrategyService
   * Accepts either a predefined config, or a custom one
   * @param details
   */
  build(details: GuidedV2StrategyDataStarter & {localeHack?:LocaleHack}): GuidedV2StrategyService {
      const predefined = (details?.predefined in predefinedConfigs)
        ? predefinedConfigs[details.predefined]
        : {};

      let configObject = {
        ...GuidedV2Defaults,
        ...predefined,
        ...details.params,
      };


      if(details.localeHack){
        const {country,language} = details.localeHack;
        configObject = JSON.parse(JSON.stringify(configObject).replace(/\$CC/g,country).replace(/\$LL/g,language));
      }

      const service = new GuidedV2DefaultService(configObject);

      if (details.external) {

        fetch(details.external)
          .then(r => r.json())
          .then(cfg => {
              service.details = {
                ...service.details,
                ...cfg
              };
          }).catch(e => {
              // eslint-disable-next-line no-console
              console.error('Error loading external config for Guided V2', e);
          });

      }

      if (details.localeHack) {
        service.details.country = details.localeHack.country;
        service.details.language = details.localeHack.language;
      }

      return service;

  }

}
